import Image from "../../image";
import Text from "../../text/text";
import SimSlider from "./sim-slider";
import SimDetail from "./sim-detail";
import { useCrimeSceneStore } from "src/store/crimeSceneStore";
import AIAgentButton from "@/components/button/ai-agent-button";

interface SimNavPanelProps {
  onChatClick: () => void;
  isChatActive?: boolean;
}

const SimNavPanel: React.FC<SimNavPanelProps> = ({
  onChatClick,
  isChatActive = false,
}) => {
  const setIsShownIncidentOccurence = useCrimeSceneStore(
    (state) => state.setIsShownIncidentOccurence
  );

  const chatButton = () => {
    return (
      <div
        onClick={() => {
          onChatClick();
        }}
        className={`relative flex items-center rounded-full btn-style backdrop-blur transition-all duration-300 overflow-hidden ${
          isChatActive ? "actived" : ""
        }`}
      >
        {/* Trigger shows current mode icon when collapsed */}
        <span className="flex items-center justify-center px-[20px] h-[38px] shrink-0">
          <Image
            aria-hidden
            src="/assets/icon_chat.png"
            alt="chat icon"
            width={22}
            height={22}
          />{" "}
          <Text text="chat" className="hidden md:block ml-[8px] text-500" />
        </span>
      </div>
    );
  };

  return (
    <div className="p-[20px]">
      <div className="relative">
        <div className="gradient-border-outer">
          <div className="gradient-border md:flex md:h-[72px]">
            {/* Content */}
            <div className="flex">
              <SimDetail />
            </div>

            <div className="flex flex-1 mt-[20px] md:mt-[0px] mb-[32px] md:mb-[0px] md:items-center md:m0">
              <SimSlider />
            </div>

            <div className="flex items-center justify-between gap-3 md:justify-center">
              <AIAgentButton
                onClick={() => {
                  setIsShownIncidentOccurence(true);
                }}
              />
              {chatButton()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimNavPanel;
